import { useMutation } from '@tanstack/react-query';
import type { ForgotPasswordInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';

interface ForgotPasswordApiResponse {
  success: boolean;
  data: { message: string };
}

/**
 * Mutation hook for forgot password request.
 * Calls POST /auth/forgot-password.
 */
export function useForgotPassword() {
  return useMutation<void, Error, ForgotPasswordInput>({
    mutationFn: async (input) => {
      await apiClient.post<ForgotPasswordApiResponse>('/auth/forgot-password', input);
    },
  });
}
